import { useState } from "react";
import { ZoomIn, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const StepItem = ({ i, text, img, onZoom }) => (
  <li className="grid md:grid-cols-[minmax(0,1fr)_300px] md:gap-5 items-center bg-[#0F1218] border border-[#27303E] rounded-sm overflow-hidden" data-testid={`faq-step-${i}`}>
    <div className="flex gap-3 sm:gap-4 p-4 md:p-6 order-2 md:order-1">
      <span className="font-display text-2xl sm:text-3xl font-black text-amber-500 w-8 sm:w-10 shrink-0 leading-none">{String(i + 1).padStart(2, "0")}</span>
      <span className="text-[15px] sm:text-base text-slate-200 leading-relaxed">{text}</span>
    </div>
    {img && (
      <button type="button" onClick={() => onZoom(i)} data-testid={`faq-step-image-btn-${i}`} className="group relative order-1 md:order-2 aspect-[3/2] md:aspect-auto md:h-full md:min-h-[190px] overflow-hidden">
        <img src={img} alt={`Step ${i + 1}: ${text}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-testid={`faq-step-image-${i}`} />
        <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 bg-[#0B0D10]/85 border border-[#27303E] px-2 py-1 rounded-sm font-mono text-[10px] uppercase tracking-widest text-slate-200 opacity-90 group-hover:border-amber-500 transition-colors duration-200">
          <ZoomIn size={12} /> Zoom
        </span>
      </button>
    )}
  </li>
);

export const StepList = ({ steps, images = [] }) => {
  const [zoom, setZoom] = useState(null);
  return (
    <>
      <ol className="space-y-4">
        {steps.map((s, i) => <StepItem key={i} i={i} text={s} img={images[i]} onZoom={setZoom} />)}
      </ol>
      <Dialog open={zoom !== null} onOpenChange={(o) => !o && setZoom(null)}>
        <DialogContent className="w-[calc(100vw-1.5rem)] max-w-5xl p-0 bg-[#0B0D10] border-[#27303E] overflow-hidden rounded-sm [&>button]:hidden" data-testid="step-image-dialog">
          {zoom !== null && (
            <>
              <img src={images[zoom]} alt={steps[zoom]} className="w-full max-h-[75vh] object-contain bg-black" />
              <div className="flex items-start justify-between gap-4 p-5">
                <DialogTitle className="text-base font-normal text-slate-200 leading-relaxed">
                  <span className="font-display text-amber-500 font-bold uppercase mr-2">Step {String(zoom + 1).padStart(2, "0")}</span>{steps[zoom]}
                </DialogTitle>
                <button onClick={() => setZoom(null)} data-testid="step-image-close-btn" className="text-slate-400 hover:text-white"><X size={20} /></button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
